module.exports = __webpack_public_path__ + "img/MM_Main_01.4d94d7a4.png";